import {Component, computed, input, signal} from '@angular/core';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {RouterOutlet} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {of, switchMap} from 'rxjs';
import {PasswordValidationRulesComponent} from './password-validation-rules/password-validation-rules.component';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    standalone: true,
    imports: [
        RouterOutlet,
        TranslateModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        PasswordValidationRulesComponent,
        MatInputModule,
        AngularSvgIconModule
    ]
})
export class InputComponent
{
    public fieldName = input.required<string>();

    public control = input.required<FormControl>();
    
    public showErrors = input<boolean>(true);
    
    public showPasswordErrors = input<boolean>(false);

    public suffix = input<string>();

    private readonly controlDisabled$ = toObservable(this.control).pipe(switchMap((control: FormControl) => of(control?.disabled ?? false)));

    public readonly disabled = toSignal(this.controlDisabled$);
    
    public focused = signal<boolean>(false);
    
    public type = input<'text' | 'password' | 'number' | 'textarea'>('text');
    
    public isTextArea = computed(() => this.type() === 'textarea');

    public readonly isPassword = computed(() => this.type() === 'password');

    public readonly showPassword = signal<boolean>(false);

    public changeInputType(event: Event): void
    {
        this.showPassword.set(!this.showPassword());

        event.stopPropagation();
    }

    public getInputTypeIcon(): string
    {
        return this.showPassword() ? 'assets/icons/eye-slash.svg' : 'assets/icons/eye.svg';
    }
}
